var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7841 50.2304C86.7232 49.9037 88.9116 47.7155 89.2383 44.7764C90.5219 33.2267 90.3195 30.07 87.5392 18.2617C86.8316 15.2562 84.3437 12.7683 81.338 12.061C69.5309 9.28144 66.3737 9.07868 54.8237 10.3616C51.8844 10.6881 49.696 12.8765 49.3695 15.8158C48.0864 27.3646 72.2353 51.5137 83.7841 50.2304Z",
    fill: "url(#paint0_radial_5224_182239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3657 14.8197C50.0759 14.8518 49.7939 14.9028 49.5198 14.97C49.4526 15.2441 49.4016 15.5263 49.3695 15.8159C48.0864 27.3645 72.2355 51.5134 83.7843 50.2303C84.074 50.1982 84.356 50.1472 84.6301 50.0799C84.6973 49.8059 84.7483 49.5237 84.7804 49.2341C86.0634 37.6855 61.9144 13.5366 50.3657 14.8197Z",
    fill: "url(#paint1_linear_5224_182239)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2245 69.3792C24.4114 63.5661 20.5003 58.0524 21.4887 57.0639L57.3036 21.249C58.292 20.2606 63.8058 24.1717 69.6189 29.9848C75.4321 35.7979 79.3432 41.3116 78.3548 42.3L42.5397 78.115C41.5513 79.1034 36.0377 75.1923 30.2245 69.3792Z",
    fill: "url(#paint2_linear_5224_182239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7553 70.8717C26.5815 65.444 23.2767 60.5913 24.2131 59.6549L61.1501 22.718C63.4471 24.2771 66.4894 26.8543 69.62 29.9847C75.4331 35.7978 79.3443 41.3115 78.3559 42.2999L42.5406 78.115C41.6396 79.016 36.9767 75.844 31.7553 70.8717Z",
    fill: "url(#paint3_linear_5224_182239)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5397 78.1151C43.5281 77.1267 39.617 71.6129 33.8041 65.7997C27.991 59.9866 22.4773 56.0755 21.4887 57.0639C20.5003 58.0523 24.4114 63.5661 30.2244 69.3793C36.0375 75.1924 41.5513 79.1035 42.5397 78.1151Z",
    fill: "url(#paint4_linear_5224_182239)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9827 74.5576C39.637 73.9033 37.0479 70.253 33.1994 66.4047C29.3509 62.5562 25.7008 59.9671 25.0465 60.6214C24.3921 61.2758 26.9813 64.9261 30.8298 68.7744C34.678 72.6228 38.3283 75.212 38.9827 74.5576Z",
    fill: "url(#paint5_linear_5224_182239)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5781 75.8504L66.0908 47.3377C70.3429 43.0857 69.2027 34.9959 63.5013 29.2243C63.4438 29.166 63.3859 29.1078 63.3278 29.0497C60.6817 26.4036 58.099 24.1539 55.9755 22.5787L57.3049 21.2492C58.2933 20.2608 63.8071 24.1719 69.6202 29.985C75.4334 35.7982 79.3445 41.3118 78.3561 42.3002L42.541 78.1151C42.0026 78.6535 40.1195 77.7355 37.5781 75.8504Z",
    fill: "url(#paint6_linear_5224_182239)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77521 52.5287L16.7625 40.5415C17.836 39.4681 19.5769 39.4665 20.6519 40.5415C21.7254 41.615 21.7254 43.3575 20.6519 44.431L8.66462 56.4181C4.44221 60.6405 4.44221 67.5107 8.66462 71.7331C12.887 75.9555 19.7572 75.9555 23.9796 71.7331L31.0972 64.6155C31.1205 64.5922 31.144 64.5687 31.1673 64.5486C31.8237 65.0932 32.5099 65.717 33.1976 66.4047C33.8853 67.0924 34.5091 67.7785 35.0537 68.435C35.0334 68.4583 35.0101 68.4818 34.9868 68.5051L27.8692 75.6227C21.503 81.9888 11.1416 81.9888 4.77538 75.6227C-1.59256 69.2547 -1.59097 58.8948 4.77521 52.5287Z",
    fill: "url(#paint7_linear_5224_182239)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5537 72.9343L34.9829 68.5051C35.0062 68.4818 35.0297 68.4585 35.0498 68.435C34.5052 67.7785 33.8814 67.0924 33.1937 66.4047C32.5059 65.717 31.8198 65.0932 31.1634 64.5486C31.1401 64.5689 31.1166 64.5922 31.0933 64.6155L26.6641 69.0447L30.5537 72.9343Z",
    fill: "url(#paint8_linear_5224_182239)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0569 44.4817L16.1382 48.4505C16.5142 49.8309 18.2412 50.2897 19.2529 49.2782L22.1076 46.4234C22.5802 45.9508 23.2697 45.7676 23.9145 45.9432L27.1372 46.8212C28.5274 47.1999 29.803 45.9245 29.4243 44.5341L28.5463 41.3114C28.3707 40.6666 28.5539 39.9771 29.0265 39.5045L31.8813 36.6498C32.8928 35.6382 32.434 33.9111 31.0536 33.5351L27.0848 32.4538C26.4481 32.2803 25.9506 31.7829 25.7772 31.1462L24.6959 27.1774C24.3199 25.797 22.5929 25.3382 21.5814 26.3497L18.7266 29.2045C18.254 29.6771 17.5646 29.8602 16.9197 29.6846L13.697 28.8067C12.3068 28.428 11.0313 29.7035 11.41 31.0938L12.2879 34.3165C12.4635 34.9613 12.2803 35.6508 11.8077 36.1234L8.95297 38.9781C7.94145 39.9896 8.40027 41.7168 9.78062 42.0928L13.7494 43.1741C14.386 43.3474 14.8834 43.8448 15.0569 44.4817Z",
    fill: "url(#paint9_linear_5224_182239)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4688 32.7823L15.9596 32.1209C15.0869 31.8909 14.2914 32.6897 14.5249 33.5614L15.1838 36.0216C15.2929 36.4289 15.1755 36.8634 14.8761 37.1602L13.3798 38.6438C12.7342 39.2838 13.0286 40.3831 13.9078 40.6148L15.9453 41.1518C16.3529 41.2592 16.6718 41.5769 16.7811 41.984L17.44 44.4442C17.6735 45.316 18.7618 45.6101 19.4027 44.9747L21.2454 43.1475C21.541 42.8544 21.9698 42.7395 22.3724 42.8455L24.8816 43.5069C25.7542 43.7369 26.5498 42.9382 26.3163 42.0664L25.6574 39.6062C25.5483 39.1989 25.6656 38.7645 25.9651 38.4677L27.4614 36.9841C28.1069 36.344 27.8124 35.2448 26.9334 35.0131L24.8959 34.4761C24.4882 34.3686 24.1694 34.0509 24.0601 33.6438L23.4012 31.1837C23.1677 30.3119 22.0794 30.0177 21.4385 30.6532L19.5958 32.4804C19.3002 32.7735 18.8715 32.8884 18.4688 32.7823Z",
    fill: "url(#paint10_linear_5224_182239)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2068 34.4327L13.703 35.1147C12.8321 35.3519 12.5427 36.4414 13.1808 37.0795L14.9817 38.8804C15.2798 39.1785 15.3954 39.6135 15.2845 40.0204L14.7306 42.0535C14.4917 42.9306 15.2964 43.7353 16.1734 43.4964L18.2065 42.9424C18.6133 42.8316 19.0483 42.9472 19.3464 43.2452L21.1473 45.0461C21.7854 45.6842 22.8749 45.3948 23.1121 44.524L23.7941 42.0202C23.9035 41.6185 24.2175 41.3046 24.6191 41.1952L27.1229 40.5131C27.9936 40.276 28.2832 39.1864 27.6451 38.5483L25.8442 36.7474C25.5461 36.4494 25.4305 36.0144 25.5414 35.6074L26.0953 33.5743C26.3343 32.6972 25.5295 31.8925 24.6525 32.1315L22.6194 32.6854C22.2126 32.7962 21.7776 32.6807 21.4795 32.3826L19.6787 30.5817C19.0405 29.9436 17.951 30.233 17.7137 31.1039L17.0316 33.6077C16.9224 34.0093 16.6084 34.3231 16.2068 34.4327Z",
    fill: "url(#paint11_linear_5224_182239)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1604 40.6216L18.6157 42.2928C18.774 42.8741 19.5013 43.0673 19.9273 42.6413L21.1294 41.4392C21.3284 41.2402 21.6187 41.1631 21.8903 41.237L23.2474 41.6067C23.8329 41.7662 24.3699 41.2291 24.2104 40.6435L23.8407 39.2865C23.7667 39.0149 23.8439 38.7246 24.0429 38.5255L25.245 37.3234C25.671 36.8974 25.4778 36.1702 24.8965 36.0119L23.2252 35.5566C22.9569 35.4835 22.7474 35.2741 22.6744 35.0058L22.2191 33.3346C22.0608 32.7533 21.3334 32.5601 20.9076 32.9861L19.7054 34.1882C19.5064 34.3873 19.2161 34.4644 18.9445 34.3905L17.5874 34.0208C17.0019 33.8612 16.4649 34.3984 16.6243 34.9839L16.994 36.341C17.0679 36.6126 16.9908 36.9029 16.7917 37.1019L15.5896 38.3041C15.1636 38.7301 15.3569 39.4573 15.9382 39.6156L17.6093 40.0709C17.8779 40.1439 18.0874 40.3534 18.1604 40.6216Z",
    fill: "url(#paint12_linear_5224_182239)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1258 43.1485L16.9908 46.3238C17.2917 47.4281 18.6735 47.7952 19.4828 46.9859L21.7666 44.702C22.1446 44.3238 22.6965 44.1774 23.2123 44.3178L25.7907 45.0202C26.903 45.3232 27.9235 44.3027 27.6205 43.1904L26.9182 40.612C26.7777 40.0961 26.9242 39.5443 27.3024 39.1663L29.5862 36.8824C30.3955 36.0731 30.0285 34.6914 28.9241 34.3905L25.7489 33.5254C25.2394 33.3867 24.8413 32.9886 24.7026 32.4791L23.8375 29.3039C23.5366 28.1995 22.1549 27.8325 21.3456 28.6418L19.0617 30.9257C18.6835 31.3038 18.1319 31.4503 17.6161 31.3098L15.0376 30.6075C13.9254 30.3045 12.9048 31.325 13.2078 32.4373L13.9102 35.0157C14.0508 35.5315 13.9042 36.0834 13.526 36.4614L11.2421 38.7452C10.4328 39.5545 10.7999 40.9363 11.9042 41.2372L15.0795 42.1022C15.5889 42.2411 15.9869 42.6391 16.1258 43.1485Z",
    fill: "url(#paint13_linear_5224_182239)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0641 30.3995C33.2861 30.3995 34.2767 29.4089 34.2767 28.187C34.2767 26.965 33.2861 25.9744 32.0641 25.9744C30.8422 25.9744 29.8516 26.965 29.8516 28.187C29.8516 29.4089 30.8422 30.3995 32.0641 30.3995Z",
    fill: "url(#paint14_linear_5224_182239)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36884 48.8505C5.14678 48.8505 4.15625 47.8598 4.15625 46.6379C4.15625 45.416 5.14678 44.4253 6.36884 44.4253C7.59072 44.4253 8.58143 45.4158 8.58143 46.6379C8.58143 47.8598 7.59072 48.8505 6.36884 48.8505Z",
    fill: "url(#paint15_linear_5224_182239)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.325 32.4802C35.7141 32.4802 35.2188 31.9848 35.2188 31.3739C35.2188 30.7629 35.7141 30.2676 36.325 30.2676C36.936 30.2676 37.4313 30.7629 37.4313 31.3739C37.4313 31.9848 36.936 32.4802 36.325 32.4802Z",
    fill: "url(#paint16_linear_5224_182239)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4422 46.4973C11.8313 46.4973 11.3359 46.0019 11.3359 45.391C11.3359 44.78 11.8313 44.2847 12.4422 44.2847C13.0532 44.2847 13.5485 44.78 13.5485 45.391C13.5485 46.0019 13.0534 46.4973 12.4422 46.4973Z",
    fill: "url(#paint17_linear_5224_182239)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4735 52.0373C24.8625 52.0373 24.3672 51.5419 24.3672 50.931C24.3672 50.3201 24.8625 49.8247 25.4735 49.8247C26.0844 49.8247 26.5798 50.3201 26.5798 50.931C26.5798 51.5421 26.0846 52.0373 25.4735 52.0373Z",
    fill: "url(#paint18_linear_5224_182239)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.536 42.7831C34.147 42.7831 34.6423 42.2878 34.6423 41.6769C34.6423 41.0659 34.147 40.5706 33.536 40.5706C32.925 40.5706 32.4297 41.0659 32.4297 41.6769C32.4297 42.2878 32.925 42.7831 33.536 42.7831Z",
    fill: "url(#paint19_linear_5224_182239)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6694 64.9802L49.7663 70.8833H38.4746C37.1474 69.2942 35.56 67.5605 33.7994 65.7999C33.5213 65.5217 33.2451 65.2491 32.9688 64.98H55.6694V64.9802Z",
    fill: "url(#paint20_linear_5224_182239)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8377 52.8145L61.9346 58.7176H25.5981C23.4889 57.2495 21.9612 56.5867 21.4844 57.0635L25.7334 52.8145H67.8377Z",
    fill: "url(#paint21_linear_5224_182239)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3532 42.301L74.1041 46.5501H32L37.9031 40.647H78.1635C78.5337 41.4631 78.6131 42.0391 78.3532 42.301Z",
    fill: "url(#paint22_linear_5224_182239)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7105 34.3843H44.1641L50.0672 28.4812H68.0746C68.5839 28.967 69.0985 29.4689 69.615 29.9854C71.1265 31.4969 72.5096 32.9884 73.7105 34.3843Z",
    fill: "url(#paint23_linear_5224_182239)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8369 52.8145L61.9338 58.7176H25.5972C25.5069 58.6544 25.4167 58.593 25.3281 58.5333L31.0472 52.8145H67.8369Z",
    fill: "url(#paint24_linear_5224_182239)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5029 41.8496C78.5029 42.0464 78.4542 42.1981 78.3511 42.301L74.102 46.5501H37.3125L43.2176 40.647H78.1616C78.2193 40.7753 78.2717 40.8979 78.3133 41.0135C78.3333 41.0659 78.3513 41.1164 78.3675 41.1653C78.3982 41.2537 78.4234 41.3386 78.4416 41.4199C78.4489 41.4452 78.4543 41.4704 78.4596 41.4958C78.4796 41.5807 78.4921 41.6601 78.4976 41.7342C78.5011 41.7737 78.5029 41.8117 78.5029 41.8496Z",
    fill: "url(#paint25_linear_5224_182239)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7069 34.3843H49.4766L55.3797 28.4812H68.0709C68.0981 28.5064 68.1251 28.5336 68.1521 28.5606C68.6342 29.021 69.1218 29.4961 69.6112 29.9854C70.0174 30.3917 70.4166 30.7981 70.803 31.2008C70.9566 31.3578 71.1064 31.5168 71.2544 31.6739C71.258 31.6757 71.2599 31.6774 71.2617 31.6811C71.4007 31.8257 71.5361 31.972 71.6716 32.1163C72.2224 32.7068 72.7497 33.2883 73.248 33.8572C73.3257 33.9456 73.4033 34.0342 73.4792 34.1226C73.5553 34.2091 73.631 34.2977 73.7069 34.3843Z",
    fill: "url(#paint26_linear_5224_182239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5224_182239",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.3118 1.12497) scale(35.5211 35.5211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#FFD744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6278,
    stopColor: "#FFCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7926,
    stopColor: "#FFC237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    stopColor: "#FFAF2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5224_182239",
    x1: 61.8144,
    y1: 47.5096,
    x2: 67.7736,
    y2: 30.5351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5224_182239",
    x1: 43.9296,
    y1: 43.7309,
    x2: 56.9034,
    y2: 56.7046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5224_182239",
    x1: 71.5267,
    y1: 57.5,
    x2: 2.25591,
    y2: 53.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5224_182239",
    x1: 29.7273,
    y1: 68.6216,
    x2: 33.938,
    y2: 65.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5224_182239",
    x1: 30.4985,
    y1: 68.2831,
    x2: 33.2862,
    y2: 66.4785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5224_182239",
    x1: 58.7452,
    y1: 52.0622,
    x2: 84.9295,
    y2: 51.3487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5224_182239",
    x1: 9.9034,
    y1: 78.1901,
    x2: 21.4144,
    y2: 57.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5224_182239",
    x1: 30.5765,
    y1: 69.1988,
    x2: 32.9099,
    y2: 65.4656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674D66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5224_182239",
    x1: 27.9071,
    y1: 37.7151,
    x2: 9.14787,
    y2: 37.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5224_182239",
    x1: 23.8775,
    y1: 34.3571,
    x2: 14.8898,
    y2: 43.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5224_182239",
    x1: 17.6514,
    y1: 44.7024,
    x2: 25.8346,
    y2: 24.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5224_182239",
    x1: 23.5995,
    y1: 37.7151,
    x2: 15.6999,
    y2: 37.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5224_182239",
    x1: 19.1579,
    y1: 39.2625,
    x2: 31.7686,
    y2: 24.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5224_182239",
    x1: 32.7083,
    y1: 27.543,
    x2: 30.1539,
    y2: 30.0972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5224_182239",
    x1: 7.01278,
    y1: 45.9938,
    x2: 4.45854,
    y2: 48.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5224_182239",
    x1: 36.6471,
    y1: 31.0518,
    x2: 35.37,
    y2: 32.3289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5224_182239",
    x1: 12.7643,
    y1: 45.0689,
    x2: 11.4872,
    y2: 46.3462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5224_182239",
    x1: 25.7955,
    y1: 50.6091,
    x2: 24.5184,
    y2: 51.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5224_182239",
    x1: 33.8579,
    y1: 41.355,
    x2: 32.5807,
    y2: 42.6319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5224_182239",
    x1: 41.2666,
    y1: 73.6745,
    x2: 44.0215,
    y2: 65.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5224_182239",
    x1: 40.4055,
    y1: 67.0606,
    x2: 45.1891,
    y2: 53.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5224_182239",
    x1: 50.9425,
    y1: 56.5537,
    x2: 56.0439,
    y2: 42.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5224_182239",
    x1: 56.6386,
    y1: 40.9323,
    x2: 59.9374,
    y2: 31.5357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5224_182239",
    x1: 48.7454,
    y1: 57.0852,
    x2: 35.834,
    y2: 48.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5224_182239",
    x1: 57.5828,
    y1: 43.4982,
    x2: 44.6712,
    y2: 35.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5224_182239",
    x1: 63.4488,
    y1: 34.4731,
    x2: 50.5372,
    y2: 26.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworks);
export default __webpack_public_path__ + "static/media/fireworks.1063c5bc7660c57b0dbbf17b99c092b8.svg";
export { ForwardRef as ReactComponent };